// extracted by mini-css-extract-plugin
export default {"container":"builder_container__oIrk1","loader":"builder_loader__y5fjf"};